import AnalyticsEvent from './analytics-event';
import { BrandProperty, createBrandProperty } from '../properties/brand-property';

export default class BrandUnlikedEvent extends AnalyticsEvent {
  public readonly name = 'Brand Unliked';
  public properties: {
    brand: BrandProperty;
    id_section?: string;
  };

  constructor(brand: BrandProperty, id_section?: string) {
    super();
    this.properties = {
      brand: createBrandProperty(brand),
    };
    if (id_section) {
      this.properties.id_section = id_section;
    }
  }
}
